import React from "react";

import { Dropdown } from "@components/General/Dropdown/dropdown.component";
import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { getLabel } from "@components/General/LanguageSelector/partials/label.component";

import "./dropdown.scss";
import { DropdownLanguageItem } from "./drownDownLanguageItem.component";

type Props = {
    variant?: string;
    languages: Language[];
    current: string;
};

const LanguageDropDownSelector = ({
    current,
    languages = [],
    variant,
}: Props) => {
    const currentLanguageObject = languages.find(
        language => language.languageCode === current,
    );
    const currentLabel = current?.toUpperCase() || "";

    return (
        <Dropdown
            className="language-selector__dropdown"
            placeholder={
                !currentLanguageObject
                    ? currentLabel
                    : getLabel(currentLanguageObject!, variant)
            }
        >
            {languages.map(language => (
                <DropdownLanguageItem
                    key={language.languageCode}
                    language={language}
                    isDisabled={language.languageCode === current}
                    variant={variant}
                />
            ))}
        </Dropdown>
    );
};

export default LanguageDropDownSelector;
